import React from "react";

export const Help = () => {
    return (
        <div>
            <div className="instruction-usb-mode ml-40 my-20">
                <div className="bold red">Requires USB mode set to MIDI.</div>
                <div className="mt-10">
                    If you are using USB HOST mode on your controller:
                </div>
                <ol>
                    <li>Plug in USB cable</li>
                    <li>Wait 1 second</li>
                    <li>Hold the left footswitch to enter SETUP</li>
                    <li>Controller will temporarily set itself to USB MIDI</li>
                    <li>Hold right footswitch to exit setup when finished editing, or power-cycle controller</li>
                </ol>
                <div className="my-20 mt-20">
                    <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/VCfWZVmIoTY"
                        title="YouTube video player" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen></iframe>
                </div>
                <div className="title2">
                    How to use the renamer:
                </div>
                <div className="mt-10 line-125">
                    After connecting your device, give the app a few seconds to recognize the device and read its configuration.
                </div>
                <div className="mt-20 line-125">
                    If the renamer display the version and SN (serial number) of your device, everything's ok and you can proceed with the configuration.<br />
                </div>
                <div className="mt-5">
                    Otherwise :
                </div>
                <ol>
                    <li>refresh the renamer window in your browser with Cmd-R (Mac) or F5 (Windows.)</li>
                    <li>check the MIDI input and MIDI output selection.</li>
                    <li>check the USB mode of the DMC.micro (see above.)</li>
                    <li>check your cable.</li>
                </ol>
                <div className="title2">
                    Need help?  Have feedback about the renamer?
                </div>
                <div className="mt-10 line-125">
                    Please contact us using the <a href="https://www.disasterareadesigns.com/support">support page</a>.
                </div>
            </div>
        </div>
    );

}